<div
  class="main-content ticket-detalle-page"
  [style.--ticket-status-color]="getStatusColor()"
  [style.--ticket-priority-color]="getPriorityColor()">
  <div class="container-fluid" *ngIf="tickets.id_ticket; else detailFallback">
    <section class="ticket-detalle-page__hero">
      <div class="ticket-detalle-page__hero-main">
        <div class="ticket-detalle-page__hero-title-row">
          <span class="ticket-detalle-page__ticket-id">
            #{{ tickets.id_ticket }}
          </span>

          <div class="ticket-detalle-page__hero-copy">
            <h1>{{ tickets.asunto || "Ticket sin asunto" }}</h1>
            <p>
              {{ tickets.tipoSolicitud || "Solicitud general" }}
              <span class="ticket-detalle-page__hero-divider">|</span>
              {{ tickets.nombreSolicitante || "Solicitante no identificado" }}
            </p>
          </div>

          <span
            class="ticket-detalle-page__status-chip"
            [ngClass]="getStatusChipClass()">
            {{ tickets.nombreEstaus || "Sin estatus" }}
          </span>
        </div>
      </div>

      <div class="ticket-detalle-page__hero-actions">
        <button
          type="button"
          mat-raised-button
          class="btn app-form-btn app-form-btn--secondary"
          (click)="onCloseClick()">
          Regresar
        </button>

        <button
          *ngIf="canEditTicket()"
          type="button"
          mat-raised-button
          class="btn app-form-btn app-form-btn--secondary"
          (click)="solicitudTickets()">
          Editar solicitud
        </button>

        <button
          *ngIf="canMoveToProcess()"
          type="button"
          mat-raised-button
          class="btn app-form-btn"
          (click)="avanzarDeEstatus()">
          En proceso
        </button>

        <button
          *ngIf="canMoveToAtendida()"
          type="button"
          mat-raised-button
          class="btn app-form-btn"
          (click)="avanzarDeEstatusAtendido()">
          Atender
        </button>

        <button
          *ngIf="canCancelTicket()"
          type="button"
          mat-raised-button
          class="btn app-form-btn app-form-btn--secondary ticket-detalle-page__cancel-btn"
          (click)="ticketCancelado()">
          Cancelar
        </button>

        <button
          *ngIf="canClientCloseTicket()"
          type="button"
          mat-raised-button
          class="btn app-form-btn"
          (click)="cerrarTicketCliente()">
          Cerrar
        </button>

        <button
          *ngIf="canClientReopenTicket()"
          type="button"
          mat-raised-button
          class="btn app-form-btn app-form-btn--secondary"
          (click)="reabrirTicketCliente()">
          Reabrir
        </button>

        <button
          *ngIf="canClientCancelTicket()"
          type="button"
          mat-raised-button
          class="btn app-form-btn app-form-btn--secondary ticket-detalle-page__cancel-btn"
          (click)="cancelarTicketCliente()">
          Cancelar
        </button>
      </div>
    </section>

    <div class="ticket-detalle-page__layout">
      <div class="ticket-detalle-page__main">
        <div class="ticket-detalle-page__meta-grid">
          <section class="ticket-detalle-page__card ticket-detalle-page__card--compact">
            <header class="ticket-detalle-page__eyebrow-header">
              Información Técnica
            </header>

            <div class="ticket-detalle-page__kv-list">
              <div class="ticket-detalle-page__kv-item">
                <span>Prioridad</span>
                <strong
                  class="ticket-detalle-page__priority-chip"
                  [ngClass]="getPriorityChipClass()">
                  {{ tickets.prioridad || "Sin definir" }}
                </strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Tipo</span>
                <strong
                  class="ticket-detalle-page__type-chip"
                  [ngClass]="getTypeChipClass()">
                  {{ tickets.tipoSolicitud || "General" }}
                </strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>SLA</span>
                <strong>{{ getSlaLabel() }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Tiempo atención</span>
                <strong>{{ tickets.tiempoAtencionString || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Área solicitante</span>
                <strong>{{ tickets.areaSolicitante || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Área resolutora</span>
                <strong>{{ tickets.areaResolutora || "N/A" }}</strong>
              </div>
            </div>
          </section>

          <section class="ticket-detalle-page__card ticket-detalle-page__card--compact">
            <header class="ticket-detalle-page__eyebrow-header">
              Registro y Seguimiento
            </header>

            <div class="ticket-detalle-page__kv-list">
              <div class="ticket-detalle-page__kv-item">
                <span>Solicitante</span>
                <strong>{{ tickets.nombreSolicitante || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Empresa</span>
                <strong>{{ tickets.nombreEmpresaSolicitante || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Fecha solicitud</span>
                <strong>{{ formatDetailDate(tickets.fechaSolicitudConFormato || tickets.fechaSolicitud) || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Última afectación</span>
                <strong>{{ formatDetailDate(tickets.fechaUltimaAfectacion) || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Teléfono</span>
                <strong>{{ tickets.telefonoContacto || "N/A" }}</strong>
              </div>

              <div class="ticket-detalle-page__kv-item">
                <span>Responsable proceso</span>
                <strong>{{ tickets.nombreUsuarioProceso || "N/A" }}</strong>
              </div>
            </div>
          </section>
        </div>

        <section class="ticket-detalle-page__card">
          <header class="ticket-detalle-page__section-header">
            <mat-icon>description</mat-icon>
            <h2>Descripción y Justificación</h2>
          </header>

          <div class="ticket-detalle-page__description">
            <p *ngIf="tickets.justificacion; else emptyDescription">
              {{ tickets.justificacion }}
            </p>
            <ng-template #emptyDescription>
              <p class="ticket-detalle-page__muted">
                No hay justificación registrada para este ticket.
              </p>
            </ng-template>
          </div>
        </section>

        <section class="ticket-detalle-page__card" *ngIf="esMejora && mejora">
          <header class="ticket-detalle-page__section-header">
            <mat-icon>upgrade</mat-icon>
            <h2>Datos de Mejora</h2>
          </header>

          <div class="ticket-detalle-page__detail-grid">
            <article class="ticket-detalle-page__detail-tile">
              <span>Área / Proyecto</span>
              <strong>{{ mejora.area_proyecto_aplica || "N/A" }}</strong>
            </article>
          </div>
        </section>

        <section class="ticket-detalle-page__card" *ngIf="esPerfil && ticketPerfil">
          <header class="ticket-detalle-page__section-header">
            <mat-icon>badge</mat-icon>
            <h2>Datos de Perfil</h2>
          </header>

          <div class="ticket-detalle-page__detail-grid">
            <article class="ticket-detalle-page__detail-tile">
              <span>Perfil solicitado</span>
              <strong>{{ ticketPerfil.perfil || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Nivel de perfil</span>
              <strong>{{ ticketPerfil.nivelPerfil || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Cantidad de perfiles</span>
              <strong>{{ ticketPerfil.numPerfiles || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Años de experiencia</span>
              <strong>{{ ticketPerfil.experiencia || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Cliente</span>
              <strong>{{ ticketPerfil.nombreCliente || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Ubicación cliente</span>
              <strong>{{ ticketPerfil.ubicacionCliente || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Proyecto</span>
              <strong>{{ ticketPerfil.tipoProyecto || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Lugar de trabajo</span>
              <strong>{{ ticketPerfil.lugarTrabajo || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Fecha inicio</span>
              <strong>{{ formatDetailDate(ticketPerfil.fechaInicio) || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Fecha fin</span>
              <strong>{{ formatDetailDate(ticketPerfil.fechaFin) || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Tipo de contratación</span>
              <strong>{{ ticketPerfil.tipoContratacion || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Horario</span>
              <strong>{{ ticketPerfil.horario || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Tarifa</span>
              <strong>{{ ticketPerfil.tarifa || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Sueldo oferta</span>
              <strong>{{ ticketPerfil.sueldoOferta || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Esquema sueldo</span>
              <strong>{{ ticketPerfil.esquemaSueldo || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Aprobado por</span>
              <strong>{{ ticketPerfil.aprobadoPor || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Inglés</span>
              <strong>{{ ticketPerfil.ingles || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Equipo requerido</span>
              <strong>{{ ticketPerfil.equipoRequerido || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Recurso disponible</span>
              <strong>{{ getProfileAvailabilityLabel() }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile ticket-detalle-page__detail-tile--wide">
              <span>Conocimiento deseable</span>
              <strong>{{ ticketPerfil.conocimientoDeseable || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile ticket-detalle-page__detail-tile--wide">
              <span>Consideraciones</span>
              <strong>{{ ticketPerfil.consideraciones || "N/A" }}</strong>
            </article>
          </div>
        </section>

        <section class="ticket-detalle-page__card" *ngIf="ticketCapacitacion">
          <header class="ticket-detalle-page__section-header">
            <mat-icon>school</mat-icon>
            <h2>Datos de Capacitación</h2>
          </header>

          <div class="ticket-detalle-page__detail-grid">
            <article class="ticket-detalle-page__detail-tile">
              <span>Curso</span>
              <strong>{{ ticketCapacitacion.nombreCurso || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Tema requerido</span>
              <strong>{{ ticketCapacitacion.temaRequerido || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Fecha requerida</span>
              <strong>{{ formatDetailDate(ticketCapacitacion.fechaReqCap) || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile">
              <span>Nivel</span>
              <strong>{{ ticketCapacitacion.nivelCurso || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile ticket-detalle-page__detail-tile--wide">
              <span>Objetivo</span>
              <strong>{{ ticketCapacitacion.objetivoCurso || "N/A" }}</strong>
            </article>

            <article class="ticket-detalle-page__detail-tile ticket-detalle-page__detail-tile--wide">
              <span>Observaciones</span>
              <strong>{{ ticketCapacitacion.observaciones || "N/A" }}</strong>
            </article>
          </div>

          <div
            class="ticket-detalle-page__people-list"
            *ngIf="ticketCapacitacion.personalCap?.length">
            <span class="ticket-detalle-page__people-title">Personal a capacitar</span>

            <div class="ticket-detalle-page__people-chips">
              <span
                class="ticket-detalle-page__person-chip"
                *ngFor="let empleado of ticketCapacitacion.personalCap">
                {{ getEmpleadoNombre(empleado) }}
              </span>
            </div>
          </div>
        </section>

        <section class="ticket-detalle-page__card">
          <header class="ticket-detalle-page__section-header ticket-detalle-page__section-header--split">
            <div class="ticket-detalle-page__section-title">
              <mat-icon>attach_file</mat-icon>
              <h2>Evidencias Generales</h2>
            </div>

            <span class="ticket-detalle-page__section-meta">
              {{ allEvidencias.length }} archivo(s)
            </span>
          </header>

          <div class="ticket-detalle-page__evidence-grid" *ngIf="allEvidencias.length; else emptyEvidence">
            <article class="ticket-detalle-page__evidence-item" *ngFor="let item of allEvidencias; trackBy: trackByEvidenceKey">
              <div class="ticket-detalle-page__evidence-icon">
                <mat-icon>{{ iconoEvidencia(item.evidencia) }}</mat-icon>
              </div>

              <div class="ticket-detalle-page__evidence-copy">
                <strong>{{ item.evidencia.nombre }}</strong>
                <span>
                  {{ item.nombreUsuario || "Sin usuario" }}
                  <span class="ticket-detalle-page__evidence-divider">|</span>
                  {{ formatDetailDate(item.fecha) || "Sin fecha" }}
                </span>
              </div>

              <div class="ticket-detalle-page__evidence-actions">
                <button
                  type="button"
                  mat-icon-button
                  class="btn"
                  (click)="consultaEvidencia(item.evidencia)"
                  *ngIf="esPrevisualizable(item.evidencia)"
                  matTooltip="Ver evidencia">
                  <mat-icon>visibility</mat-icon>
                </button>

                <button
                  type="button"
                  mat-icon-button
                  class="btn"
                  (click)="descargaEvidencia(item.evidencia)"
                  matTooltip="Descargar evidencia">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </article>
          </div>

          <ng-template #emptyEvidence>
            <p class="ticket-detalle-page__empty">
              No hay evidencias cargadas para este ticket.
            </p>
          </ng-template>
        </section>
      </div>

      <aside class="ticket-detalle-page__sidebar">
        <section class="ticket-detalle-page__card ticket-detalle-page__activity-card">
          <header class="ticket-detalle-page__section-header ticket-detalle-page__section-header--split">
            <div class="ticket-detalle-page__section-title">
              <mat-icon>forum</mat-icon>
              <h2>Historial de Comentarios</h2>
            </div>

            <span class="ticket-detalle-page__history-count">
              {{ listComentario.length }}
            </span>
          </header>

          <div class="ticket-detalle-page__comments-list" *ngIf="listComentario.length > 0; else emptyTimeline">
            <article class="ticket-detalle-page__comment-card" *ngFor="let item of listComentario; trackBy: trackByComentarioId">
              <div class="ticket-detalle-page__comment-head">
                <div class="ticket-detalle-page__comment-author-block">
                  <div class="ticket-detalle-page__comment-avatar">
                    {{ getInitials(item.nombreUsuario) }}
                  </div>

                  <div class="ticket-detalle-page__comment-author-copy">
                    <strong>{{ item.nombreUsuario || "Sistema" }}</strong>
                    <span>{{ formatDetailDate(item.fecha) || "Sin fecha" }}</span>
                  </div>
                </div>

                <span
                  class="ticket-detalle-page__timeline-status"
                  [ngClass]="getStatusChipClass(item.nombreEstatus)">
                  {{ item.nombreEstatus || "Sin estatus" }}
                </span>
              </div>

              <div class="ticket-detalle-page__comment-body">
                {{ item.descripcion || "Sin comentario registrado." }}
              </div>

              <div class="ticket-detalle-page__timeline-files" *ngIf="getTimelineEvidencias(item).length > 0">
                <button
                  type="button"
                  class="ticket-detalle-page__timeline-file"
                  *ngFor="let evidencia of getTimelineEvidencias(item)"
                  [matTooltip]="esPrevisualizable(evidencia) ? 'Ver evidencia' : 'Descargar evidencia'"
                  (click)="consultaEvidencia(evidencia)">
                  <mat-icon>{{ iconoEvidencia(evidencia) }}</mat-icon>
                  <span>{{ evidencia.nombre }}</span>
                </button>
              </div>
            </article>
          </div>

          <ng-template #emptyTimeline>
            <p class="ticket-detalle-page__empty">
              No hay actividad registrada para este ticket.
            </p>
          </ng-template>

          <div class="ticket-detalle-page__composer-container" *ngIf="canShowCommentComposer()">
            <form [formGroup]="formComentario" (ngSubmit)="saveInlineComment()">
              <div class="ticket-detalle-page__composer-header">
                <div class="ticket-detalle-page__comment-avatar ticket-detalle-page__comment-avatar--composer">
                  {{ getInitials(nombreUsuarioLogeado || tickets.nombreUsuarioProceso || tickets.nombreSolicitante) }}
                </div>

                <div class="ticket-detalle-page__composer-input-shell">
                  <textarea
                    formControlName="descripcion"
                    class="ticket-detalle-page__composer-input"
                    placeholder="Escribe un comentario..."
                    aria-label="Escribe un comentario..."
                    rows="1"></textarea>

                  <button
                    type="submit"
                    class="ticket-detalle-page__composer-send-btn"
                    [disabled]="!canSendInlineComment()"
                    matTooltip="Enviar comentario">
                    <mat-icon>
                      {{ submittingInlineComment ? "hourglass_top" : "send" }}
                    </mat-icon>
                  </button>
                </div>
              </div>

              <div class="ticket-detalle-page__composer-footer">
                <label class="ticket-detalle-page__action-link ticket-detalle-page__action-link--attach">
                  <mat-icon>attach_file</mat-icon>
                  Adjuntar
                  <input
                    type="file"
                    multiple
                    hidden
                    accept="image/*,application/*,audio/*,video/*"
                    (change)="addCommentFiles($event)" />
                </label>

                <button
                  *ngIf="formComentario.controls.descripcion.value || evidenciaComentario.length"
                  type="button"
                  class="ticket-detalle-page__action-link"
                  [disabled]="submittingInlineComment"
                  (click)="limpiarComentarioInline()">
                  <mat-icon>ink_eraser</mat-icon>
                  Limpiar
                </button>
              </div>

              <div class="ticket-detalle-page__composer-files" *ngIf="evidenciaComentario.length > 0">
                <div
                  *ngFor="let file of evidenciaComentario"
                  class="ticket-detalle-page__composer-file-chip">
                  <mat-icon class="ticket-detalle-page__composer-file-icon">attachment</mat-icon>
                  <span class="ticket-detalle-page__composer-file-name">{{ file.name }}</span>

                  <button
                    type="button"
                    class="ticket-detalle-page__composer-file-remove"
                    [disabled]="submittingInlineComment"
                    (click)="removeCommentFile(file)"
                    aria-label="Eliminar archivo">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </aside>
    </div>
  </div>
</div>

<ng-template #detailFallback>
  <div class="main-content ticket-detalle-page__fallback">
    <div class="container-fluid">
      <div class="table-page__empty-state ticket-detalle-page__empty-screen">
        <mat-icon>{{ loading ? "hourglass_top" : "error_outline" }}</mat-icon>
        <p>
          {{
            loading
              ? "Cargando detalle del ticket..."
              : "No se encontró información para este ticket."
          }}
        </p>
        <button
          type="button"
          mat-raised-button
          class="btn app-form-btn app-form-btn--secondary"
          (click)="regresar()">
          Volver a tickets
        </button>
      </div>
    </div>
  </div>
</ng-template>

<a class="download-zip-link" #downloadDocument aria-label="Descargar archivo"></a>
